import React, { useEffect } from 'react';

type KeyboardShortcut = Pick<React.KeyboardEvent, 'key' | 'ctrlKey'>;

export function useKeyboardShortcut(
    { key, ctrlKey }: KeyboardShortcut,
    onKeyPressed: () => void
) {
    useEffect(() => {
        function keyDownHandler(e: KeyboardEvent) {
            const isMatch = e.key === key && e.ctrlKey === ctrlKey;
            if (!isMatch) {
                return;
            }

            e.preventDefault();
            onKeyPressed();
        }

        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [key, ctrlKey, onKeyPressed]);
}
